import { render, staticRenderFns } from "./AdminOperators.vue?vue&type=template&id=5c2c58a2&scoped=true"
import script from "./AdminOperators.vue?vue&type=script&lang=js"
export * from "./AdminOperators.vue?vue&type=script&lang=js"
import style0 from "./AdminOperators.vue?vue&type=style&index=0&id=5c2c58a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2c58a2",
  null
  
)

export default component.exports